import { useEffect, useState } from 'react';
import { Typography } from '../Typography';

interface InactivityWarningMessageProps {
  initialSeconds: number;
}

const InactivityWarningMessage: React.FC<InactivityWarningMessageProps> = ({
  initialSeconds,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => Math.max(0, prev - 1));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography
      className="flash-notification__content-wrapper__text ms-2"
      color="color-27"
      variant="size-16"
      weight="regular"
    >
      You&apos;ve been inactive for a while. To protect your account, you will
      be automatically logged out in{' '}
      <Typography
        component="span"
        color="color-27"
        variant="size-16"
        weight="bold"
      >
        {secondsLeft} seconds
      </Typography>
      .
    </Typography>
  );
};

export default InactivityWarningMessage;
